import WdacCatalogInventoryTable from '../../../wdac-results/tabs/WdacCatalogInventory/WdacCatalogInventoryTable';
import useGetCatalogInventorySectionDevices from '../../../../queries/catalogInvectoryDetails/useGetCatalogInventorySectionDevices';

const CatalogInventorySection = () => {
  const {
    isLoading,
    data: catalogInventoryList,
    lastElementRef,
    isFetching,
    count,
    unsignedCount,
    query,
  } = useGetCatalogInventorySectionDevices();

  return (
    <WdacCatalogInventoryTable
      isLoading={isLoading}
      isFetching={isFetching}
      catalogInventoryList={catalogInventoryList}
      lastElementRef={lastElementRef}
      totalCount={count}
      unsignedCount={unsignedCount}
      query={query}
    />
  );
};

export default CatalogInventorySection;
